module.exports = __webpack_public_path__ + "img/parcel-delivered.6313d0a7.svg";